import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';

export type BoardNameMappingDTO = Record<string, string>;

const getBoardNameMapping = async (country?: string) => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: '/board_name_mapping',
    params: country ? { country } : undefined,
  };

  const { data } = await axios.request<BoardNameMappingDTO>(config);

  return data;
};

export default getBoardNameMapping;
